import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';

import { TabsModule } from 'primeng/tabs';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { LeadActivityTabsComponent } from 'src/app/private/components/leads/lead-activity-tabs/lead-activity-tabs.component';
import { LeadStatusComponent } from 'src/app/private/components/leads/lead-status/lead-status.component';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { DatePickerModule } from 'primeng/datepicker';
import { Calendar } from 'primeng/calendar';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { RegistrationStatusComponent } from "../../registration/registration-status/registration-status.component";
import { ApplicationStatusComponent } from "../../application/application-status/application-status.component";
import { catchError, forkJoin, of } from 'rxjs';
import { EnrollmentStatusComponent } from "../../enrollment/enrollment-status/enrollment-status.component";
import { AdmissionStatusComponent } from "../admission-status/admission-status.component";
import { AdmissionService } from 'src/app/private/services/admission.service';
@Component({
  selector: 'app-admission-profile-middle-screen',
  imports: [SharedModule, LeadActivityTabsComponent, DatePickerModule, AdmissionStatusComponent],
  templateUrl: './admission-profile-middle-screen.component.html',
  styleUrl: './admission-profile-middle-screen.component.scss'
})
export class AdmissionProfileMiddleScreenComponent {

today: Date = new Date();
  createFieldFormValue: any = {};
  previousLeadData: any = {};
  isSubmitted: boolean = false;
  fieldValues: { [key: string]: any } = {};

  @ViewChild('dobPicker') dobPicker!: Calendar;
  @Output() handleUpdateData = new EventEmitter<any>();

  @Input() fullUserList: any = [];
  @Input() fullCourseList: any = [];

  @Input() paymentForList: any = [];

  openDatePicker() {
    this.dobPicker.overlayVisible = true;
  }

  closeDatePicker() {
    this.dobPicker.overlayVisible = false;
  }

  @Input() allLeadFeilds: any = [];
  @Input() editAdmissionData: any = {};
  @Input() editType: any = 'admission';
  @Input() feeGroups: any = [];

  @Input() users = [];
  
  @Input() academicYearList: any[] = [];
  @Input() batchList: any[] = []
  @Input() feeCategoryList: any[] = [];
  @Input() admissionStatusList: any[] = []
  @Input() departmentList: any[] = [];

  @Input() transportRouteList: any[] = [];
  @Input() hostelList: any[] = []
  @Input() scholarshipList: any[] = [];

  activeTab: number | string = -1;

  constructor(private api: LeadService, private localStorage: LocalStorageService, private messageService: MessageService,
    private leadActivityService: LeadActivityService,
    private admissionApi : AdmissionService
  ) { }

  isLoading: boolean = false;
  @Input() allCourses: any = [];


  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  admissionTypes: any[] = [
    { label: 'New Admission', value: 'New Admission' },
    {label :'Regular', value: 'Regular'},
    { label: 'Transfer Admission', value: 'Transfer Admission' },
    { label: 'Re-Admission', value: 'Re-Admission' },
    { label: 'Lateral Admission', value: 'Lateral Admission' }
  ];

  leadTypes: any[] = [
    { label: 'New Lead', value: 'New Lead' },
    { label: 'Cold Lead', value: 'Cold Lead' },
    { label: 'Warm Lead', value: 'Warm Lead' },
    { label: 'Hot Lead', value: 'Hot Lead' }
  ];

  leadStatusList: any[] = [
    { value: 'Assigned', label: 'Assigned' },
    { value: 'Working', label: 'Working' },
    { value: 'Qualified', label: 'Qualified' },
    { value: 'Raw', label: 'Raw' },
    { value: 'Unqualified', label: 'Unqualified' },
  ];

  queryTypes: any[] = [
    { label: 'General', value: 'General' },
    { label: 'Admission', value: 'Admission' },
    { label: 'Application', value: 'Application' },
    { label: 'Fee Structure', value: 'Fee Structure' },
    { label: 'Registration', value: 'Registration' },
    { label: 'Placement', value: 'Placement' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Course', value: 'Course' },
    { label: 'Other', value: 'Other' }
  ];

  genderOptions: any[] = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  prefixOptions: any[] = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
  ];


  documentStatusList = [
    { label: 'Verified', value: 'verified' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' }
  ];

  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];


  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  modeOfStudyOptions: any[] = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  paymentStatusList = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Failed', value: 'Failed' }
  ];

  paymentModeList = [
    { label: 'Cash', value: 'Cash' },
    { label: 'Credit Card', value: 'Credit Card' },
    { label: 'Debit Card', value: 'Debit Card' },
    { label: 'Bank Transfer (NEFT/RTGS/IMPS)', value: 'Bank Transfer' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'UPI (Google Pay / PhonePe / Paytm)', value: 'UPI' },
    { label: 'Net Banking', value: 'Net Banking' },
    { label: 'Demand Draft', value: 'Demand Draft' },
    { label: 'Wallet', value: 'Wallet' },
    { label: 'Other', value: 'Other' }
  ];


  isFixedColumn: boolean = true;

  admissionModeOptions = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' }
  ];

  @Input() selectedTabIdx: number = 0;

  @Output() changeTab = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editAdmissionData'] && changes['editAdmissionData'].currentValue != changes['editAdmissionData'].previousValue) {
      this.createFieldFormValue = this.editAdmissionData;
      this.fieldValues = this.editAdmissionData.dynamic_fields || {};
      this.previousLeadData = JSON.parse(JSON.stringify(this.editAdmissionData));

      this.createFieldFormValue.date_of_birth = this.editAdmissionData.date_of_birth ? new Date(this.editAdmissionData.date_of_birth) : null;
     
      console.log("formFieldValues middle", this.fieldValues);
    
    }
  }

  ngOnInit() {
    this.createFieldFormValue = this.editAdmissionData;
    this.fieldValues = this.editAdmissionData.dynamic_fields || {};
    this.previousLeadData = JSON.parse(JSON.stringify(this.editAdmissionData));

    console.log("formFieldValues middle", this.createFieldFormValue);
    this.createFieldFormValue.date_of_birth = this.editAdmissionData.date_of_birth ? new Date(this.editAdmissionData.date_of_birth) : null;

    console.log("allLeadFeilds", this.allLeadFeilds);
    this.getLeadsFields();
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: 'admission'
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
        console.log("Dynamic fields loaded for admission:", this.allLeadFeilds);
      },
      error: (error) => {
        console.error("Error loading dynamic fields:", error);
      }
    });
  }

  cities = [
    { name: 'New York', code: 'NY' },
    { name: 'Los Angeles', code: 'LA' },
    { name: 'Chicago', code: 'CH' }
  ];


  onPaymentForChange(event: any) {
    console.log("Payment For Changed:", event);
    console.log("paymentForList:", this.paymentForList);
    // make amount
    this.createFieldFormValue.enrollment_data.payment_details.amount = this.paymentForList.find((item: any) => item.value === event)?.total_fees || null;
  }

  submitForm(isValid: any) {


    this.isSubmitted = true;

    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    this.isLoading = true;

    this.createFieldFormValue.old_admission_data = this.previousLeadData;

    this.createFieldFormValue.user_id = this.localStorage.getUserId();
    this.createFieldFormValue.user = this.localStorage.getUser();

    this.createFieldFormValue.dynamic_fields = this.fieldValues;



    console.log("Updating lead with data:", this.createFieldFormValue);

    this.admissionApi.updateAdmission(this.createFieldFormValue).subscribe({
      next: (c) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Updated Successfully' });
        this.handleUpdateData.emit(
          this.createFieldFormValue
        );
        this.leadActivityService.getAllLeadTimeLineActivity(this.createFieldFormValue.lead_id);
        const { old_lead_data, ...restData } = this.createFieldFormValue;
        this.previousLeadData = restData;
        console.log(" previousLeadData", this.previousLeadData)
        // this.createFieldFormValue = {};
        // this.fieldValues = {};
        // this.previousLeadData = {};
        this.isSubmitted = false;

      },
      error: (e) => {
        this.isLoading = false;
        this.isSubmitted = false;
        console.log('Error occurred:', e);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      },
      complete: () => { },
    });

  }

  onTabChange(event: any) {
    console.log('Tab Changed:', event);
    this.activeTab = event;
    this.changeTab.emit(event);
  }

}
